import { SearchService } from '@sportworld/js-sdk/src/service/search'

import useStore from '@/store/useStore'
import { TileType } from '@/types/servicesTypes/configTypes'
import { SearchQuery } from '@/types/servicesTypes/searchTypes'

export const getSuggestions = async (term: string) => {
  const { setSuggestions, setLoading, setError } = useStore.getState().search
  try {
    setSuggestions([])
    setLoading('suggestions')
    setError('suggestions', false)
    const data = await SearchService.searchSuggest(term)
    setSuggestions(data)
  } catch (e) {
    setError('suggestions')
  } finally {
    setLoading('suggestions', false)
  }
}

export const getData = async (term: string, type: SearchQuery, next = '') => {
  const { appConfig } = useStore.getState().common
  const { setPages, setEvents, setLoading, setError } =
    useStore.getState().search
  const typeKey = type === 'event' ? 'events' : 'pages'
  const setter = type === 'event' ? setEvents : setPages
  try {
    setLoading(typeKey)
    setError(typeKey, false)
    const queryParams = { term, next, type, limit: appConfig.limitTilesPerLine }
    const data = await SearchService.searchQuery<TileType>(queryParams, true)
    setter(data)
  } catch (e) {
    setError(typeKey)
  } finally {
    setLoading(typeKey, false)
  }
}
